import { Text } from 'app/components/ui/Text'
import { Tooltip } from 'app/components/ui/Tooltip'
import React from 'react'
import InfoIcon from 'static/icons/info.svg'
import styled, { useTheme } from 'styled-components'

type Props = {
  tooltipText: string
  className?: string
}
export const FormTooltip = ({
  tooltipText,
  children,
  className,
}: WithChildren<Props>): JSX.Element => {
  const theme = useTheme()

  return (
    <Wrapper className={className}>
      {children}
      <StyledTooltip
        shadow
        width='300px'
        content={<img src={InfoIcon} alt='info_icon'></img>}
        direction='left'
      >
        <Text variant='s14' color={theme.color.primari.grigioEstra}>
          {tooltipText}
        </Text>
      </StyledTooltip>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
`

const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`
